<template>
  <div class="home-container">
    <h1 class="page-title">Test</h1>
    <hr class="mb-0" />
    <div class="partition-form">
      <form class="pb-4" autocomplete="false" @submit.prevent="submitRequest">
        <div class="custom-form-elements">
          <div class="input-group input-group-icon">
            <input
              v-model="productUrl"
              type="text"
              placeholder="Product URL"
              required
            />
            <div class="input-icon"><i class="pe-7s-link"></i></div>
          </div>
        </div>
      </form>

      <button
        type="submit"
        name="button"
        class="add-product-btn w-100 mt-4"
        v-on:click="submitRequest"
      >
        Submit
      </button>
      {{ foo }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  components: {},

  data() {
    return {
      productUrl: null,
      foo: null
    };
  },

  methods: {
    submitRequest() {
      (async () => {
        this.foo = axios({
          method: "get",
          url: this.productUrl
        });
        console.log("response: ", this.foo);
      })();

      console.log("response after: ", this.foo);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_breakpoints.scss";
@import "~@/styles/_colour-palette.scss";
// Modal
// ------------------------------
// TODO: This is required for modal - Seems to shrink width when removed even
// though DOM element is not in this file
.modal-lg {
  max-width: 80%;
}

.home-container {
  .filters-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 50px auto;
    padding: 10px;

    .sidebar-filter-btn {
      cursor: pointer;
      background-color: white;
      min-width: 50px;
      width: 125px;
      margin-bottom: 0;
      padding: 10px 15px;
      opacity: 0.8;

      &:last-child {
        margin-left: 15px;
      }

      &:hover {
        background-color: $grey8;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
          0 1px 2px 0 rgba(0, 0, 0, 0.06);
        opacity: 1;

        .icon {
          &.fresh {
            fill: $emerald;
          }

          &.hot {
            fill: $alizarin;
          }
        }
      }

      &.active {
        opacity: 1;
        background-color: $grey8;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
          0 1px 2px 0 rgba(0, 0, 0, 0.06);

        .icon {
          &.fresh {
            fill: $emerald;
          }

          &.hot {
            fill: $alizarin;
          }
        }
      }

      .icon {
        fill: $grey3;
        margin-right: 15px;
        font-size: 16px;
      }

      .text {
        font-size: 14px;
      }
    }
  }
  .feature-tour-icon {
    cursor: pointer;
    font-size: 24px;
    padding: 10px;
  }
  .brands-title {
    letter-spacing: 1.4px;
    font-size: 12px;
    font-weight: 400;
    color: $grey3;
  }

  .partners-wrapper {
    margin-top: 26px;
    margin-bottom: 60px;
  }
}
.v-tour__target--highlighted /deep/ {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/pages/Test.vue